import { Column, Dot, Row } from 'components/Blocks';
import { useLang } from 'hooks/lang';

const msgs = ['req-directly-yo-reprice', 'you-wont-be-able-to-invoice', 'pm-wont-be-able-to'];

export function InvoiceOriginNotice() {
  const { t } = useLang();

  return (
    <Column className="px-1 text-sm font-medium" gap="2">
      {msgs.map((msg) => (
        <Row key={msg} gap="2" alignItems="flex-start">
          <Dot color="primary" size={6} className="mt-2" />

          <span>{t(msg)}</span>
        </Row>
      ))}
    </Column>
  );
}
